import { render, staticRenderFns } from "./UploadProductsStep.vue?vue&type=template&id=c10b62ac&scoped=true&"
import script from "./UploadProductsStep.vue?vue&type=script&lang=ts&"
export * from "./UploadProductsStep.vue?vue&type=script&lang=ts&"
import style0 from "./UploadProductsStep.vue?vue&type=style&index=0&id=c10b62ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b62ac",
  null
  
)

export default component.exports